<template>
  <div class="mt-5">
    <v-sheet
      class="transactionTable change-mt5-password-tab px-8 pt-10 pb-10"
      elevation="0"
      :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'"
    >
      <div class="status-bar pt-0">
        <h2>Change Account Type</h2>
        <p>You can send a request to your broker, if broker accept
          that, your account type will be changed.</p>
      </div>
      <v-card class="deposit-form" :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'">
        <v-row>
          <v-col cols="12" sm="12" md="12" lg="12">
            <fieldset>
              <legend>MT5 Account</legend>
              <v-select
                :items="slots2"
                v-model="selectedAccount"
                single-line
                solo
                hide-details
                append-icon="mdi-chevron-down"
                class="custom-select"
              >
              </v-select>
            </fieldset>
          </v-col>
          <v-col cols="12" sm="12" md="12" lg="12">
            <fieldset>
              <legend>Desired Account Type</legend>
              <v-select
                :items="slots1"
                v-model="selectedAccount2"
                single-line
                solo
                hide-details
                append-icon="mdi-chevron-down"
                class="custom-select"
              >
              </v-select>
            </fieldset>
          </v-col>
          <v-col cols="12" sm="12" md="12" lg="12">
            <v-alert v-if="errorMessage" type="error" class="mb-4">
              {{ errorMessage }}
            </v-alert>

            <v-btn
              color="greenMain"
              large
              tile
              block
              elevation="0"
              class="ma-0 mt-0 text-capitalize btn-account"
              v-bind="attrs"
              v-on="on"
              @click="savePassword"
              :loading="loading"
              :disabled=true
            >
              Save Password
            </v-btn>
          </v-col>
        </v-row>
      </v-card>
    </v-sheet>
  </div>
</template>

<script>


export default {
  data: () => ({
    selectedAccount:'99109 (Premium Account)',
    selectedAccount2:'Elite Account',
    slots2: ["99109 (Premium Account)", "Crypto Payment TCN"],
    slots1: ["Elite Account", "Crypto Payment TCN"],
  }),

  
};
</script>
